import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';

export interface SaveMetadata {
  slot: string;
  scenarioId: string;
  playerFactionId: string;
  playerFactionName: string;
  year: number;
  month: number;
  turn: number;
  savedAt: string;
}

export class SaveManager {
  static readonly instance = new SaveManager();

  save(slot = 'autosave') {
    const campaign = GameState.instance.requireCampaign();
    const metadata: SaveMetadata = {
      slot,
      scenarioId: campaign.scenarioId,
      playerFactionId: campaign.playerFactionId,
      playerFactionName: DataRegistry.instance.factions[campaign.playerFactionId]?.name ?? campaign.playerFactionId,
      year: campaign.year,
      month: campaign.month,
      turn: campaign.turn,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem(`coj:${slot}`, JSON.stringify({ metadata, campaign }));
    this.writeSlotIndex(slot);
  }

  load(slot = 'autosave') {
    const raw = localStorage.getItem(`coj:${slot}`);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { campaign?: typeof GameState.instance.campaign };
    if (!parsed.campaign) return false;
    GameState.instance.campaign = parsed.campaign;
    GameState.instance.migrateCampaign(parsed.campaign);
    return true;
  }

  delete(slot: string) {
    localStorage.removeItem(`coj:${slot}`);
    const slots = this.slots().filter((entry) => entry.slot !== slot).map((entry) => entry.slot);
    localStorage.setItem('coj:slots', JSON.stringify(slots));
  }

  hasSave(slot = 'autosave') {
    return localStorage.getItem(`coj:${slot}`) !== null;
  }

  slots(): SaveMetadata[] {
    const slots = JSON.parse(localStorage.getItem('coj:slots') ?? '["autosave"]') as string[];
    return slots
      .map((slot) => {
        const raw = localStorage.getItem(`coj:${slot}`);
        if (!raw) return undefined;
        return (JSON.parse(raw) as { metadata: SaveMetadata }).metadata;
      })
      .filter((metadata): metadata is SaveMetadata => Boolean(metadata));
  }

  private writeSlotIndex(slot: string) {
    const slots = new Set(JSON.parse(localStorage.getItem('coj:slots') ?? '[]') as string[]);
    slots.add(slot);
    localStorage.setItem('coj:slots', JSON.stringify([...slots]));
  }
}
